import { render, staticRenderFns } from "./formio-test-render.vue?vue&type=template&id=fefafcb8"
import script from "./formio-test-render.vue?vue&type=script&lang=js"
export * from "./formio-test-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports